import React from 'react'
import { useSelector } from 'react-redux'
import { userSelectors } from '../../redux/userSlice'
import { Redirect, Route } from 'react-router'
import { UserTypes } from '../../util/constants'

const AuthenticatedRoute = ({ path, component, ...props }) => {
    const isLoggedIn = useSelector(userSelectors.isLoggedIn)
    const userType = useSelector(userSelectors.userType)

    if (isLoggedIn && userType !== UserTypes.Beneficiary) {
        return <Route path={path} component={component} {...props} />
    }

    return <Redirect to={'/app/auth/sign-in'} />
}

export default AuthenticatedRoute
